import React from 'react'
import Editor from './Editor'
import MobileEditor from './MobileEditor'
import MobileDetect from 'mobile-detect'

const EditorSwitch = React.forwardRef<any, any>((props, ref) => {
  if (new MobileDetect(window.navigator.userAgent).mobile()) {
    return <MobileEditor {...props} ref={ref} />
  } else {
    return <Editor {...props} ref={ref} />
  }
})

export default EditorSwitch
